// src/pages/Appli/AppliAdmin/clubs-admin/components/ClubsAdminHeader.jsx

import React from "react";

import {
  FaBuilding,
  FaGlobe,
  FaMapMarkedAlt,
  FaUsers,
} from "react-icons/fa";

function CompactStat({
  icon,
  label,
  value,
  accent = "indigo",
}) {
  const accents = {
    indigo:
      "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",

    emerald:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",

    amber:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",

    blue:
      "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
  };

  return (
    <div
      className={`rounded-2xl border px-3 py-3 ${accents[accent]}`}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/80 dark:bg-slate-900/50">
          {icon}
        </div>

        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-[0.16em] opacity-75">
            {label}
          </p>

          <p className="mt-0.5 text-xl font-bold text-slate-900 dark:text-white">
            {Number(value || 0).toLocaleString("fr-FR")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function ClubsAdminHeader({
  totalClubs,
  totalDepartments,
  totalSites,
  totalAdherents,
}) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Administration
            </p>

            <h1 className="mt-1 text-2xl font-bold text-slate-900 sm:text-[30px] dark:text-white">
              Gestion des clubs
            </h1>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Gestion des clubs de la Ligue Nouvelle-Aquitaine,
              des licenciés déclarés et des utilisateurs rattachés.
            </p>
          </div>

          <div className="grid gap-3 sm:grid-cols-2 xl:min-w-[760px] xl:grid-cols-4">
            <CompactStat
              icon={<FaBuilding />}
              label="Clubs visibles"
              value={totalClubs}
              accent="indigo"
            />

            <CompactStat
              icon={<FaUsers />}
              label="Licenciés"
              value={totalAdherents}
              accent="blue"
            />

            <CompactStat
              icon={<FaMapMarkedAlt />}
              label="Départements"
              value={totalDepartments}
              accent="emerald"
            />

            <CompactStat
              icon={<FaGlobe />}
              label="Sites renseignés"
              value={totalSites}
              accent="amber"
            />
          </div>
        </div>
      </div>
    </div>
  );
}